import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
  Grid,
  GridColumn as Column,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
  getSelectedState,
  GridCellProps,
  GridNoRecords
} from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import { checkJobType, timeSince } from "../../utils/EllowUtils";
import PopOver from "../popover";
import { DropDown } from "./myDropDown";
import { Navigate, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';


const DATA_ITEM_KEY: string = 'jobId';
const SELECTED_FIELD: string = 'selected';
const idGetter = getter(DATA_ITEM_KEY);


const ResourceTable = (props: any) => {

  const navigate = useNavigate()

  let products: { jobId: string, allocatedTo: string }[] = props.data

  const [dataState, setDataState] = useState(props.data && props.data.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem)
  ));
  //vishnu
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const redirection = (jobId: string, positionName: string, companyName: string) => {
    localStorage.setItem('PositionsJobId', jobId);
    localStorage.setItem('PositionsPositionName', positionName);
    localStorage.setItem('PositionsCompanyName', companyName);
    openInNewTab(`${window.location.origin}/position-details`)
    //navigate('../position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName } })
  }


  const [selectedState, setSelectedState] = useState<{
    [id: string]: boolean | number[];
  }>({});
  const [selectedCandidates, setSelectedCandidates] = useState<{ name: string, jobId: string, company: string }[]>([]);

  useEffect(() => {
    setSelectedState(props.selectedState)
    setDataState(props.data && props.data.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem)
    ))
  }, [products])


  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);

      if (!event.dataItem.selected) {
        let selected = [...selectedCandidates, event.dataItem]
        setSelectedCandidates(selected)
        props.onSelection(selected)
      } else {
        const index = selectedCandidates.findIndex(item => item.jobId === event.dataItem.jobId);;
        if (index > -1) {
          selectedCandidates.splice(index, 1);
        }
        setSelectedCandidates(selectedCandidates)
        props.onSelection(selectedCandidates)
      }
    },
    [selectedState]
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: any = {}
      event.dataItems.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      let candidates = []
      if (checked) {
        candidates = event.dataItems
      } else {
        candidates = []
      }
      props.onSelection(candidates)
    },
    []
  )

  return (
    <div className="tableStyle">
      <Grid
         data={dataState && dataState.map((item: any) => ({
          ...item,
          [SELECTED_FIELD]: selectedState[idGetter(item)],
        }))}
        style={{ height: '400px' }}
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        selectable={{
          enabled: true,
          drag: false,
          cell: false,
          mode: 'multiple',
        }}
        onSelectionChange={onSelectionChange}
        onHeaderSelectionChange={onHeaderSelectionChange}
        onPageChange={props.pageChange}
        total={props.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column
          field={SELECTED_FIELD}
          width="50px"
          headerSelectionValue={
            dataState && dataState.findIndex((item: any) => !selectedState[idGetter(item)]) === -1
          }
        />
        <Column field="priority" title="Priority" cell={(props: GridCellProps) => DropDown(props)} width="80px" />
        <Column field="positionName" title="JobTitle" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string, positionName: string, companyName: string) => redirection(candidateLoginId, positionName, companyName))} />
        <Column field="company" title="Company" cell={companyCell} />
        <Column field="jobType" title="JobType" cell={jobTypeCell} />
        <Column field="experience" title="Experience" cell={experienceCell} />
        <Column field="Skills" title="Skills" cell={skillsCell} />
        <Column field="OpenFor" title="OpenFor" cell={openForCell} />
        <Column field="allocatedTo" title="Allocated To" cell={allocatedToCell} />
        <Column field="profiles" title="Positions" cell={positionCountCell} />
        <Column field="profiles" title="Profiles" cell={profileCell} />
      </Grid>
    </div>
  )
}

export default ResourceTable;

const companyCell = (props: GridCellProps) => {
  
  return (
    <td >
      {props.dataItem.company}
    </td>
  )
}

const nameCell = (props: GridCellProps, redirection: any) => {
 
  return (
    <td onClick={() => redirection(props.dataItem.jobId, props.dataItem.positionName, props.dataItem.company)}>
      {props.dataItem.positionName}
    </td>
  )
}

const jobTypeCell = (props: GridCellProps) => {
  return (
    <td >
      {props.dataItem.jobType !== '' ? props.dataItem.jobType : '	Not Mentioned'}
    </td>
  )
}

const experienceCell = (props: GridCellProps) => {
  if (props.dataItem.experience !== null) {
    return <td>{props.dataItem.experienceLevel ? props.dataItem.experienceLevel.min + " - " + props.dataItem.experienceLevel.max + " Years" : 'Not Mentioned'}</td>
  } else {
    return <td>{"Not Mentioned"}</td>;
  }
}

const skillsCell = (props: GridCellProps) => {
  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
      <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
          return ((item) + (key < length - 1 ? ' , ' : ''))
        })}
      </div>
    </td>
  )
}

const openForCell = (props: GridCellProps) => {

  return <td>{timeSince(props.dataItem.createdDate)}</td>
}

const allocatedToCell = (props: GridCellProps,) => {
  return (
    <td >
      {props.dataItem.allocated_to}
    </td>
  )
}

const positionCountCell = (props: GridCellProps) => {
  return <td>{props.dataItem.positionCount ? 'Active: ' + props.dataItem.positionCount : props.dataItem.positionCount}</td>;
}

const profileCell = (props: GridCellProps) => {
  if (props.dataItem.profiles && props.dataItem.profiles.length > 1) {
    return <td><div className="positionStstus"><PopOver title="Multiple Position" position="rightBottom">
      {props.dataItem.profiles.map((item: string) => {
        return (
          <div className="positionList">
            <span className="status warning" />
            {/* <strong>{props.dataItem.company + '-' + props.dataItem.positionName}</strong> */}
            {item}
          </div>
        )
      })
      }
    </PopOver></div></td>
  } else {
    return <td>{props.dataItem.profiles}</td>
  }
}


